export default "__VITE_PUBLIC_ASSET__a97f9390__"